export const edgeOfUrawaIndependentParts = (
  ctx: CanvasRenderingContext2D,
  hudLeftColor: string,
  hudRightColor: string,
  edgeColor: string,
  hamidashiColor: string,
  stitchColor: string
): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'

  // ヘリ革＿外側
  ctx.fillStyle = edgeColor
  ctx.beginPath()
  ctx.moveTo(233, 468)
  ctx.quadraticCurveTo(249, 442, 270, 432) //右上
  ctx.quadraticCurveTo(291, 428, 310, 471)
  ctx.quadraticCurveTo(331, 518, 340, 590) // 右下
  ctx.quadraticCurveTo(312, 590, 296, 568) // 左下
  ctx.quadraticCurveTo(258, 521, 233, 468)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 本体革_左
  ctx.fillStyle = hudLeftColor
  ctx.beginPath()
  ctx.moveTo(242, 470)
  ctx.quadraticCurveTo(279, 540, 312, 570) //右上
  ctx.quadraticCurveTo(286, 508, 250, 459)
  ctx.quadraticCurveTo(243, 464, 242, 470)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 本体革_右
  ctx.fillStyle = hudRightColor
  ctx.beginPath()
  ctx.moveTo(252, 456) // 左上
  ctx.quadraticCurveTo(316, 572, 316, 572) //左下
  ctx.quadraticCurveTo(322, 579, 329, 575) //右下
  ctx.quadraticCurveTo(312, 474, 276, 444) //右上
  ctx.quadraticCurveTo(262, 446, 252, 456) //左上

  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // ハミダシ
  ctx.fillStyle = hamidashiColor
  ctx.beginPath()
  ctx.moveTo(250, 460) // 左上
  ctx.quadraticCurveTo(284, 512, 312, 571) //左下
  ctx.quadraticCurveTo(318, 575, 318, 575) //右下
  ctx.quadraticCurveTo(290, 512, 252, 456) // 右上
  ctx.quadraticCurveTo(250, 460, 250, 460)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.lineWidth = 1.1
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // 手窓
  ctx.moveTo(244, 471) // 左上
  ctx.quadraticCurveTo(254, 451, 276, 446) // 右上
  ctx.quadraticCurveTo(316, 492, 327, 576) // 右下
  ctx.quadraticCurveTo(308, 570, 279, 529)
  ctx.quadraticCurveTo(244, 471, 244, 471)
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
}
